import { ChangeEvent, ReactNode, useState } from 'react';

import './UploadField.css';

interface UploadFieldProps {
	name: string;
	title: string | ReactNode;
	required?: boolean;
	acceptedFileTypes?: string;
	maxSizeMB?: number;
}

const UploadField = ({ name, required = false, acceptedFileTypes = '.pdf,.doc,.docx,.jpg,.jpeg,.png', title }: UploadFieldProps) => {
	const [value, setValue] = useState('');
	const [fileName, setFileName] = useState<string | null>(null);

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const target = e.target;
		const files = target.files;
		setValue(target.value);
		if (files?.length) setFileName(files?.[0]?.name);
		else setFileName(null);
	};

	return (
		<label className={`upload-field ${!value ? '' : 'file-upload'}`}>
			<input name={name} type="file" value={value} onChange={handleChange} required={required} accept={acceptedFileTypes} />
			<p>
				{!fileName && <span className="icon icon-plus" />}
				<span className="file-name">{fileName ? fileName : title}</span>
			</p>
		</label>
	);
};

export default UploadField;
